import { Stack, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

import {
  StatusIndicator,
  StatusIndicatorProps,
} from './status-indicator.component';

export interface StatusHeaderProps {
  variant: StatusIndicatorProps['variant'];
  size?: StatusIndicatorProps['size'];
}

export const StatusHeader = ({
  children,
  size,
  variant,
}: PropsWithChildren<StatusHeaderProps>) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <StatusIndicator size={size} variant={variant} />
      <Typography variant="h6" gutterBottom>
        {children}
      </Typography>
    </Stack>
  );
};
